module.exports = __webpack_public_path__ + "static/media/amplification-icon.4b80d988.svg";